import LinkedItems from '../../../Assets/Images/associated-icon.svg'
import CONSTANTS, { PAGES_ROUTES } from '../../../Constants'
import { Link } from 'react-router-dom'

interface ILinkingItems {
  width?: string
  height?: string
  module?: string
  marginTop?: string
  marginBottom?: string
  navigationId?: string
}
export default function LinkingItems({
  width,
  height,
  module,
  navigationId,
  marginTop,
  marginBottom,
}: ILinkingItems) {
  const displayCategoriesList = () => {
    if (CONSTANTS.LINKED_ITEMS.length > 0) {
      return CONSTANTS.LINKED_ITEMS.map((item) => {
        return (
          <Link
            key={item.key}
            to={`${PAGES_ROUTES.AssociatedItem}/${module}/${navigationId}`}
            data-testid={`parameter-Items-${item.key}`}
            className='d-flex align-items-center justify-content-between'
            style={{
              borderTop: '1px solid #E7E8E8',
              padding: '1rem',
              fontWeight: 500,
              cursor: 'pointer',
            }}
          >
            {item.value}
          </Link>
        )
      })
    }

    return null
  }
  return (
    <div
      data-testid='parameter-Items-list'
      style={{
        minWidth: width ?? '100%',
        width: width ?? '100%',
        height: height ?? 'max-content',
        background: '#fff',
        marginTop: marginTop ?? '1.5rem',
        marginBottom: marginBottom ?? '0',
        borderRadius: '0.5rem',
      }}
    >
      <div
        className='d-flex align-item-center font-bold'
        style={{
          gap: '0.5rem',
          padding: '1.25rem 0.75rem',
        }}
      >
        <img src={LinkedItems} alt='linked items' /> Linked Items
      </div>
      {displayCategoriesList()}
    </div>
  )
}
